import Logger from "../Logger/Logger";
import * as FormData from "form-data";
import Environment from "../Environment/Environment";

class RequestNormalizer {

  private policyTransformer: string = "json";

  public normalize(data: any): any {

    const res = {};

    Object.keys(data || {}).forEach(key => {
      const value = data[key];

      // If value is NaN, send null instead.
      if (Number.isNaN(value) === true) {
        res[key] = null;
        return;
      }

      // If value is undefined, don't send it to backend.
      if (value === undefined) {
        return;
      }

      res[key] = value;
    });

    if (Environment.isDevelopment()) {
      Logger.debug(res, "RequestNormalizer");
    }

    if (res.hasOwnProperty("attachment") === true) {
      const formData = new FormData();
      const file = data.file;
      delete data.attachment.data.path;

      const json = JSON.stringify(data);
      formData.append(this.policyTransformer, json);
      formData.append("attachment", file);
      return formData;
    }

    if (res.hasOwnProperty("transactionFile") === true) {
      const formData = new FormData();
      const file = data.file;

      const json = JSON.stringify(data);
      formData.append(this.policyTransformer, json);
      formData.append("transactionFile", file);
      return formData;
    }

    return res;
  }
}

export default new RequestNormalizer();
